import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FormControl, FormGroup } from '@angular/forms';
import { PageNames } from 'src/app/configs/page-names.enum';
import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import { EventTypes } from 'src/app/core/constants/event-types';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import {
  ComparisonOperator,
  CustomResultOfPaginatedListOfCustomerDomainDto,
  GetCustomerDomainByIdDto,
} from '../../../core/api/models';
import { CustomerDomainDto } from '../../../core/api/models/customer-domain-dto';
import { PaginatedListOfCustomerDomainDto } from '../../../core/api/models/paginated-list-of-customer-domain-dto';
import { CustomerDomainsService } from '../../../core/api/services/customer-domains.service';
import { DynamicTableService } from '../../../core/services/dynamic-table.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { GetEnumValuesDto } from './../../../core/api/models/get-enum-values-dto';
import { UpdateCustomerDomainCommand } from './../../../core/api/models/update-customer-domain-command';
import { DomainDetailsComponent } from './domain-details/domain-details.component';
import { CustomerDomainFormComponent } from './domain-form/domain-form.component';
import { DesktopDirective } from './shared/desktop.directive';

@Component({
  selector: 'app-customer-domains',
  templateUrl: './customer-domains.component.html',
  imports: [
    BaseIndexModule,
    DomainDetailsComponent,
    CustomerDomainFormComponent,
    DesktopDirective,
  ],
})
export class CustomerDomainsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.customerDomains;

  /* binding service endpoints */
  protected currentService = inject(CustomerDomainsService);
  paginationApiMethodName: string =
    this.currentService.customerDomainsGetCustomerDomainsWithPagination.name;
  createGetApiMethodName: string =
    this.currentService.customerDomainsCreateGet.name;
  deleteApiMethodName: string = this.currentService.customerDomainsDelete.name;
  auditApiMethodName: string =
    this.currentService.customerDomainsGetCustomerDomainsAudit.name;
  /* binding service endpoints */

  modelWithPagination$: Observable<PaginatedListOfCustomerDomainDto>;
  items$: Observable<Array<CustomerDomainDto>>;
  formPageConfig: FormPageConfig<GetCustomerDomainByIdDto> = {};

  updateModel: UpdateCustomerDomainCommand = {};
  formDetailPageConfig: GetCustomerDomainByIdDto = {};
  isShowDetailPage: boolean = false;

  DesktopEnumValues: GetEnumValuesDto[] = [];
  LoginThemeEnumValues: GetEnumValuesDto[] = [];
  LoginPageModesEnumValues: GetEnumValuesDto[] = [];
  userDomain: string;
  form: FormGroup;

  //#endregion

  constructor(public dynamicTableService: DynamicTableService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      userDomain: new FormControl(''),
    });
  }

  getEnumsValues() {
    this.getEnumValuesApi('LoginTheme')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.LoginThemeEnumValues = values));
    this.getEnumValuesApi('Desktop')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.DesktopEnumValues = values));
    this.getEnumValuesApi('LoginPageModes')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.LoginPageModesEnumValues = values));
  }

  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.Details_key) this.onDetail(+value, false);
      if (key == QueryStringTypesEnum.Update_key) this.onUpdate(value, false);
    }
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.name, name: 'name', hasSearch: true },
      {
        hasSearch: true,
        name: 'desktop',
        title: `${this.tableVocabs}desktop`,
        type: 'enum',
        enumName: 'Desktop',
      },
      {
        title: `${this.tableVocabs}resellerIdentityDomain`,
        name: 'identityDomain',
        hasSearch: true,
      },

      {
        title: `${this.tableVocabs}resellerDomain`,
        name: 'userDomain',
        hasSearch: false,
        customOperators: [ComparisonOperator.Contains],
        noSorting: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api
  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfCustomerDomainDto> {
    return this.currentService.customerDomainsGetCustomerDomainsWithPagination({
      body: {
        ...this.getBaseModelWithPaginationParams(),
        userDomain: this.userDomain,
      },
    });
  }

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;
    this.formPageConfig.editId = id;

    this.currentService
      .customerDomainsUpdateGet({ CustomerDomainId: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  getDetailByIdApi(id: number) {
    this.currentService
      .customerDomainsGetCustomerDomainById({ CustomerDomainId: id })
      .pipe(this.basePipeOperators())
      .subscribe((item) => {
        this.formDetailPageConfig = item.data;
        this.isShowDetailPage = true;
      });
  }

  //#endregion

  //#region call Actions

  // openCreateFormModal() {
  //   try {
  //     this.unSubs();

  //     let data = {
  //       title: `${this.formPageConfig?.vocabs}addTitle`,
  //       isEdit: false,
  //     };

  //     const modalResult = this.dialogService.openModal({
  //       component: CustomerDomainFormComponent,
  //       data: data,
  //     });

  //     modalResult
  //       .afterClosed()
  //       .pipe(takeUntil(this.onDestroy$), tap(() => { AppDomService.removeModalScrollClassFromHtml() }),)
  //       .subscribe((res) => {
  //         if (res) {
  //           this.getTableData();
  //           this.cd.detectChanges();
  //         }
  //       });
  //   } catch (error) {
  //     this.loggerService.logError(this.tagName, error, EventTypes.infrastructure)
  //   }

  // }

  // openEditFormModal(model: GetCustomerDomainByIdDto) {
  //   try {
  //     this.unSubs();

  //     let data = {
  //       title: `${this.formPageConfig?.vocabs}editTitle`,
  //       model: {
  //         id: this.formPageConfig.editData.id,
  //         resellerName: model.name,
  //         loginTheme: model.loginTheme,
  //         desktop: model.desktop,
  //         resellerDomain: model.userDomain,
  //         resellerIdentityDomain: model.identityDomain,
  //         logoSrc: model.agentLogo,
  //         resellerLink: model.link
  //       },
  //       isEdit: true,
  //     };

  //     const modalResult = this.dialogService.openModal({
  //       component: CustomerDomainFormComponent,
  //       data: data,
  //     });

  //     modalResult
  //       .afterClosed()
  //       .pipe(takeUntil(this.onDestroy$), tap(() => { AppDomService.removeModalScrollClassFromHtml() }),)
  //       .subscribe((res) => {
  //         if (res) {
  //           this.getTableData();
  //           this.cd.detectChanges();
  //         }
  //       });
  //   } catch (error) {
  //     this.loggerService.logError(this.tagName, error, EventTypes.infrastructure)
  //   }

  // }

  onDetail(id: number, setFiltersAndUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setFiltersAndUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Details_key +
          '=' +
          id
      );
    }
    this.pageConfig.loading = true;

    this.getDetailByIdApi(id);
  }

  //#endregion
  onHideDetail() {
    this.showParent = true;
    this.getParentQueryString();

    this.isShowDetailPage = false;
  }

  onSearch() {
    this.getTableData();
  }
}
